export const setIncome = (state, payload) => {
  state.income = payload;
};

export const setExpenses = (state, payload) => {
  state.expenses = payload;
};